module.exports = __webpack_public_path__ + "700141f6704c695b57e0160e4ba63de2.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/TWS_gang.jpg
// module id = 892
// module chunks = 0